// removed by extract-text-webpack-plugin
module.exports = {"root":"root__r-j5D","isSecondary":"isSecondary__3TIvu","visible":"visible__jtFOo","text":"text__1daKk","offsetRight":"offsetRight__20sj8"};


//////////////////
// WEBPACK FOOTER
// ./components/RomanceBreakdownViz/Label/style.css
// module id = lQbg
// module chunks = 0